import { createFileRoute } from '@tanstack/react-router';
import { ArchivePage } from '@/features/historical-correspondence/ArchivePage';
export const Route = createFileRoute('/app/conversations_/archive')({component:ArchivePage,staticData:{title:'Historical archive'}});
